export enum LegalDocumentTypeEnum {
  TERMS_OF_SERVICE = "terms_of_service",
  PRIVACY_POLICY = "privacy_policy"
}
